import { SegmentedControl, SegmentedControlItem } from '@reelplicate/ui';
import { useNavigate } from 'react-router';

export type FlowView = 'canvas' | 'runs' | 'results';

const PATHS: Record<FlowView, string> = {
  canvas: '',
  runs: '/runs',
  results: '/results',
};

/** Figma "Canvas · Runs · Results": the three views of one flow. */
export function FlowViewSwitch({ flowId, view }: { flowId: string; view: FlowView }) {
  const navigate = useNavigate();
  return (
    <SegmentedControl
      aria-label="Flow view"
      value={view}
      onValueChange={(next) =>
        void navigate(`/flows/${flowId}${PATHS[next as FlowView]}`)
      }
    >
      <SegmentedControlItem value="canvas">Canvas</SegmentedControlItem>
      <SegmentedControlItem value="runs">Runs</SegmentedControlItem>
      <SegmentedControlItem value="results">Results</SegmentedControlItem>
    </SegmentedControl>
  );
}
